import { Button, Form } from "antd";
import { useTranslation } from "react-i18next";
import { useLoading } from "../../context/LoadingContext";
import { useForgotPassword } from "../../hooks/Authentication/auth.hooks";
import { InputRequired, PasswordFormat } from "../../validations/validations";
import CustomMessage from "../CustomMessage";
import CustomPassword from "../CustomPassword";
import { SetPasswordFormType, SetPasswordFormValues } from "./data";
import styles from "./styles.module.scss";
const SetPasswordForm: React.FC<SetPasswordFormType> = ({
  account,
  otp,
  onFinishCallback,
}) => {
  const { t } = useTranslation();
  const [form] = Form.useForm();
  const { mutate: forgetPassword } = useForgotPassword();
  const { setIsLoading } = useLoading();

  const onFinish = async (values: SetPasswordFormValues) => {
    setIsLoading(true);
    await forgetPassword(
      { params: { ...values, account: account || "", otp: otp || "" } },
      {
        onSuccess: (success: any) => {
          console.debug("success", success);
          CustomMessage({
            alertType: "success",
            alertMessage: t("success.reset.password"),
          });
          setIsLoading(false);
          setTimeout(() => {
            window.location.reload();
          }, 500);
          onFinishCallback();
        },
        onError: (error: any) => {
          setIsLoading(false);
          CustomMessage({
            alertMessage: t([
              `error.${error.data.result.code}`,
              error.data.result.message,
            ]),
            alertType: "error",
          });
        },
      }
    );
  };

  return (
    <Form
      className={styles.container}
      autoComplete={"off"}
      onFinish={onFinish}
      form={form}
      requiredMark={false}
      layout={"vertical"}
    >
      <Form.Item
        name={"new_password"}
        label={t("auth.input.newpassword")}
        rules={[
          InputRequired(t, "auth.input.password"),
          PasswordFormat(t, 6, 20),
        ]}
      >
        <CustomPassword placeholder={t("auth.hint.newpassword")} />
      </Form.Item>
      <Form.Item
        name={"confirm_new_password"}
        label={t("auth.input.repeatnewpassword")}
        rules={[
          ({ getFieldValue }) => ({
            validator(_, value) {
              if (!value || getFieldValue("new_password") === value) {
                return Promise.resolve();
              }

              return Promise.reject(new Error(t("error.repeat.pass")));
            },
          }),
        ]}
      >
        <CustomPassword placeholder={t("auth.hint.repeatpassword")} />
      </Form.Item>
      <Button type={"primary"} htmlType={"submit"} block>
        {t("normal.confirm")}
      </Button>
    </Form>
  );
};

export default SetPasswordForm;
